import { useRef, useState } from "react";

import useClickOutside from "../hooks/useClickOutside";

import { 
  HeaderContainer, 
  ContentContainer, 
  FormContainer, 
  SelectorContainer, 
  FooterContainer,
  FormErrorContainer,
  TextError
} from "./styles";

import { HiX, HiArrowNarrowLeft, HiOutlineExclamation } from 'react-icons/hi';

import Navbar from "../Navbar";

import TalkWithSeller from "../TalkWithASeller";
import LeadSupport from "../LeadSupport";
import OtherTopics from "../OtherTopics";

import { MitreFormComponent } from 'mitre-form-component'

import { ErrorBoundary } from 'react-error-boundary';

type Props = {
  productId: string,
  apiUrl: string,
  apiToken: string,
  utm_source: string,
  utm_medium?: string,
  utm_campaign?: string,
  utm_term?: string,
  close:() => void;
}

const Selector = ({ 
  productId, 
  apiUrl, 
  apiToken, 
  utm_source, 
  utm_medium, 
  utm_campaign,
  utm_term,
  close 
}:Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [ currentOpen, setCurrentOpen ] = useState(0);

  const [ currentFormOpen, setCurrentFormOpen ] = useState(-1);

  useClickOutside(ref, close);

  const tabs = [
    TalkWithSeller,
    LeadSupport,
    OtherTopics
  ];

  const DefaultComponent = () => <></>;

  const CurrentComponent = tabs[currentOpen] || DefaultComponent;

  return (
    <SelectorContainer ref={ ref }>

      <HeaderContainer>
        <HiArrowNarrowLeft 
          className="back-icon" 
          onClick={ () => setCurrentFormOpen(-1) }
          size={ 28 }
          visibility={ currentFormOpen >= 0 ? "visible" : "hidden" }
          color={ "var(--black)" }
        />

        <HiX 
          className="close-icon" 
          onClick={ close }
          size={ 28 }
          color={ "var(--black)" }
        />
      </HeaderContainer>

      { currentFormOpen >= 0 ?
        <>
          <FormContainer>
            <ErrorBoundary fallback={
                <FormErrorContainer>
                  <HiOutlineExclamation 
                    size={ 28 }
                    color={ "var(--red)" }
                  />
                  <TextError>Ocorreu um erro ao carregar o formulário!</TextError>
                </FormErrorContainer>
              }>
              <MitreFormComponent  
                productId={ productId }
                apiUrl={ apiUrl }
                apiToken={ apiToken }
                utm_source={ utm_source }
                utm_medium={ utm_medium }
                utm_campaign={ utm_campaign }
                utm_term={ utm_term }
                backgroundColor="var(--transparent)"
              />
            </ErrorBoundary>
          </FormContainer>
        </>
        : 
        <>
          <ContentContainer>
            <CurrentComponent 
                setCurrentFormOpen={setCurrentFormOpen}
                productId={ productId }
                apiUrl={ apiUrl }
                utm_source={ utm_source }
                utm_medium={ utm_medium }
                utm_campaign={ utm_campaign }
                utm_term={ utm_term }
              />
          </ContentContainer>

          <FooterContainer>
            <Navbar 
              currentOpen={ currentOpen } 
              setCurrentOpen={ setCurrentOpen }
            />
          </FooterContainer>
        </>
      }
      
    </SelectorContainer>
  );
}

export default Selector;